export default __webpack_public_path__ + "static/media/icon-notarjetas.69268a7f.svg";